import * as React from 'react'
import {getMapService} from '../../core/reducers/map'
import proj4 from 'proj4'
import {Point} from '../../core/models'

interface Props {
  left: string
}

export class MapPosition extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
  }

  render() {
    return (
      <div
        className="map-position"
        title="Моето местоположение"
        onClick={this.onClick}
        style={{left: 'auto', right: '0.5em', top: 'auto', bottom: '3em'}}
      >
        <img
          alt=""
          src="resources/icons/map-location.png"
          style={{width: '28px', height: '28px', backgroundColor: '#5c83b3b5'}}
        ></img>
      </div>
    )
  }

  onClick = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          const dstpos = proj4('EPSG:4326', 'EPSG:3857', [position.coords.longitude, position.coords.latitude])
          getMapService().setCenter(dstpos)
          if (getMapService().getZoom() < 18) {
            getMapService().setZoom(18)
          }
          const point = new Point(dstpos)
          getMapService().drawing.flash([point])
        },
        null,
        {enableHighAccuracy: true}
      )
    }
  }
}
